<app-header></app-header>

<section class="signup">
  <app-signup-form></app-signup-form>
</section>
